import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { environment } from 'src/environments/environment';
import { ModalAddQuestionComponent } from '../modal-add-question/modal-add-question.component';
import { Router } from '@angular/router';
import { MeasureManagementService } from '../measure-management.service';
import { ELearningManagementService } from '../../e-learning-management/e-learning-management.service';
import { of } from 'rxjs';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ModalAddQuestionInformantComponent } from '../modal-add-question-informant/modal-add-question-informant.component';
import { LearningCenterService } from '../../learning-center/learning-center.service';

@Component({
  selector: 'app-manage-measure',
  templateUrl: './manage-measure.component.html',
  styleUrls: ['./manage-measure.component.scss']
})
export class ManageMeasureComponent implements OnInit {
  isLoading: boolean;
  font = ['arial', 'times-new-roman', 'calibri', 'comic-sans-ms', 'th-sarabun', 'K2D'];
  measureForm: FormGroup;
  questionForm: FormGroup;
  type;
  isAddMeasure: boolean = false;
  measureId: string = null;
  isEdit: boolean;
  measureDetail: any[] = [];
  suggestCourse;
  questionDeleted = [];
  measureImg: string;
  measureImgFile: File;
  measureStatus: number;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '400px',
    maxHeight: 'auto',
    width: '100%',
    minWidth: '100%',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
      { class: 'th-sarabun', name: 'Sarabun' },
      { class: 'K2D', name: 'K2D' },
    ],
    uploadUrl: environment.URL + '/manage_admin/uploadImgaeContentNews',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top'
  };

  informant_list: any[] = [];

  allLearningCenter: any[] = [];
  learningCenter: any;
  LN_TAG: any[] = [];

  constructor(
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private gbFunction: GobalFunctionService,
    private router: Router,
    private eLearningService: ELearningManagementService,
    private measureManagementService: MeasureManagementService,
    private gobalFunctionService: GobalFunctionService,
    private learningCenterService: LearningCenterService,
  ) { }

  ngOnInit(): void {
    this.isEdit = JSON.parse(new URL(location.href).searchParams.get('isEdit'));
    this.measureForm = this.fb.group({
      language: ['TH', Validators.required],
      status: ['', Validators.required],
      font: ['', Validators.required],
      type: ['', Validators.required],
      name: ['', Validators.required],
      description: ['', Validators.required],
      measureImg: [''],
      imgEdit: [false],
      date: ['', Validators.required],
      alwaysOpen: [false],
      coin: ['', Validators.required],
      courseSuggest: [''],
      timeMeasureAgain: ['', Validators.required],
      multi_informant: [''],
      informant_tag: [''],
      showInformant: [''],
      centerId: [''],
    })

    if (this.isEdit) {
      this.measureId = new URL(location.href).searchParams.get('measure_id');
      this.gobalFunctionService.setTitle('แก้ไขแบบทดสอบ');
      this.isAddMeasure = true;
      this.measureManagementService.getDetailMeasureById(this.measureId).pipe(
        map(res => {
          console.log(res);
          this.measureForm = this.fb.group({
            language: ['TH', Validators.required],
            status: [res.result[0].STATUS_PUBLIC, Validators.required],
            font: [res.result[0].FONT, Validators.required],
            type: [res.result[0].MEASURE_TYPE, Validators.required],
            name: [res.result[0].MEASURE_NAME, Validators.required],
            description: [res.result[0].DESCRIPTION, Validators.required],
            measureImg: [res.result[0].IMAGE_MEASURE],
            imgEdit: [false],
            date: [res.result[0].ALWAYS_OPEN == 'true' ? [null] : [new Date(res.result[0].MEASURE_START), new Date(res.result[0].MEASURE_END)], Validators.required],
            alwaysOpen: [res.result[0].ALWAYS_OPEN == 'true' ? true : false],
            coin: [res.result[0].COIN, Validators.required],
            courseSuggest: [JSON.parse(res.result[0].SUGGESTION_COURSE)],
            timeMeasureAgain: [res.result[0].TIME_MEASURE_AGAIN, Validators.required],
            multi_informant: [res.result[0].IS_MULTI_INFORMANT === 0 ? false : true],
            informant_tag: [res.result[0].INFORMANT_TAG ? JSON.parse(res.result[0].INFORMANT_TAG) : ''],
            showInformant: [res.result[0].IS_SHOW_INFORMANT_PARTICIPANT_REPORT === 0 ? false : true],
            centerId: [res.result[0].LN_TAG],
          })
          this.measureStatus = res.result[0].STATUS_MEASURE;
          this.measureImg = res.result[0].IMAGE_ORIGANAL;
          this.measureDetail = res.result[0].details;
          this.informant_list = res.result[0].INFORMANT_TAG ? JSON.parse(res.result[0].INFORMANT_TAG) : [];
          this.LN_TAG = res.result[0].LN_TAG;

          if (this.measureForm.value.multi_informant) {
            this.measureForm.controls['informant_tag'].setValidators([Validators.required]);
          } else {
            this.measureForm.controls['informant_tag'].clearValidators();
          }
          this.measureForm.get('informant_tag').updateValueAndValidity();

        })
      ).subscribe();
    } else {
      this.gobalFunctionService.setTitle('สร้างแบบทดสอบ');
    }

    this.measureManagementService.getMeasureType().pipe(
      switchMap(t => {
        this.type = t.result;
        return this.eLearningService.getSuggestCourse();
      }),
      map(sc => {
        this.suggestCourse = sc.result;
      })
    ).subscribe();

    this.getAllLearning();
  }

  createMeasure(measureForm, informant) {
    this.isLoading = true;
    this.measureManagementService.createMeasure(measureForm).subscribe(res => {
      this.measureId = res.result.MEASURE_ID;
      this.isAddMeasure = true;
      this.isLoading = false;

      this.addQuestion(measureForm, informant);
    })
  }

  addQuestion(measureForm: any, informant: boolean) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;

    if (!informant) {
      this.addNormalQuestion(measureForm, dialogConfig);
    } else {
      this.addInformantQuestion(measureForm, dialogConfig);
    }
  }

  addNormalQuestion(measureForm, dialogConfig) {
    dialogConfig.data = {
      measureId: this.measureId,
      isEdit: false,
      statusEdit: false, // ใช้ในเช็คการแก้ไข กรณีแก้ไขแล้วเปลี่ยนประเภท
      title: 'เพิ่มคำถาม',
      actionBtnText: 'เสร็จสิ้น',
    }

    const modal = this.matDialog.open(ModalAddQuestionComponent, dialogConfig);
    return modal.afterClosed().pipe(
      switchMap(res => {
        // console.log('หลังจากปิด modal', res);
        if (res.status) {
          return this.measureManagementService.getDetailMeasureById(this.measureId).pipe(
            map(m => {
              // console.log(m);
              this.isAddMeasure = true;
              this.measureDetail = m.result[0].details.filter(m => !this.questionDeleted.includes(m.ID));
            })
          )
        } else {
          return of(null);
        }
      })
    ).subscribe()
  }

  addInformantQuestion(measureForm, dialogConfig) {
    dialogConfig.data = {
      measureId: this.measureId,
      isEdit: false,
      statusEdit: false, // ใช้ในเช็คการแก้ไข กรณีแก้ไขแล้วเปลี่ยนประเภท
      title: 'เพิ่มคำถาม',
      actionBtnText: 'เสร็จสิ้น',
      informant_tag: measureForm.informant_tag
    }
    const modal = this.matDialog.open(ModalAddQuestionInformantComponent, dialogConfig);
    return modal.afterClosed().pipe(
      switchMap(res => {
        // console.log('หลังจากปิด modal', res);
        if (res.status) {
          return this.measureManagementService.getDetailMeasureById(this.measureId).pipe(
            map(m => {
              // console.log(m);
              this.isAddMeasure = true;
              this.measureDetail = m.result[0].details.filter(m => !this.questionDeleted.includes(m.ID));
            })
          )
        } else {
          return of(null);
        }
      })
    ).subscribe()
  }

  editQuestion(value, informant) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;

    if (!informant) {
      this.editNormalQuestion(value, dialogConfig);
    } else {
      this.editInformantQuestion(value, dialogConfig);
    }
  }

  editNormalQuestion(value, dialogConfig) {
    dialogConfig.data = {
      measureId: this.measureId,
      id: value.ID,
      isEdit: true,
      statusEdit: true, // ใช้ในการเช็คแก้ไข กรณีแก้ไขแล้วเปลี่ยนประเภท
      title: 'แก้ไขคำถาม',
      actionBtnText: 'บันทึก',
      value: value,
    }

    const modal = this.matDialog.open(ModalAddQuestionComponent, dialogConfig);
    return modal.afterClosed().pipe(
      switchMap(res => {
        if (res.status) {
          return this.measureManagementService.getDetailMeasureById(this.measureId).pipe(
            map(m => {
              // // console.log(m);
              this.isAddMeasure = true;
              this.measureDetail = m.result[0].details.filter(m => !this.questionDeleted.includes(m.ID));
              // console.log(this.measureDetail);
            }),
            catchError((err) => {
              // console.log(err);
              alert(err.error.message)
              this.isLoading = false
              return of(null);
            })
          )
        } else {
          return of(null);
        }
      })
    ).subscribe();
  }
  editInformantQuestion(value, dialogConfig) {
    dialogConfig.data = {
      measureId: this.measureId,
      id: value.ID,
      isEdit: true,
      statusEdit: true, // ใช้ในการเช็คแก้ไข กรณีแก้ไขแล้วเปลี่ยนประเภท
      title: 'แก้ไขคำถาม',
      actionBtnText: 'บันทึก',
      value: value,
      informant_tag: this.measureForm.value.informant_tag
    }

    const modal = this.matDialog.open(ModalAddQuestionInformantComponent, dialogConfig);
    return modal.afterClosed().pipe(
      switchMap(res => {
        if (res.status) {
          return this.measureManagementService.getDetailMeasureById(this.measureId).pipe(
            map(m => {
              // // console.log(m);
              this.isAddMeasure = true;
              this.measureDetail = m.result[0].details.filter(m => !this.questionDeleted.includes(m.ID));
              // console.log(this.measureDetail);
            }),
            catchError((err) => {
              // console.log(err);
              alert(err.error.message)
              this.isLoading = false
              return of(null);
            })
          )
        } else {
          return of(null);
        }
      })
    ).subscribe();
  }

  saveMeasure(measureForm, type) {
    this.isLoading = true;
    console.log(measureForm);
    this.measureManagementService.saveMeasure(measureForm, type, this.measureId, this.questionDeleted).pipe(
      switchMap(res => {
        // console.log(res);
        this.isLoading = false;
        if (res.success) {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = true;
          dialogConfig.id = 'modalConfirm';
          dialogConfig.width = '400px';
          dialogConfig.data = {
            title: 'สำเร็จแล้ว',
            description: `<img src="../../../assets/check.png" width="100px;" class="img-center">บันทึกแบบทดสอบ "${measureForm.name}" สำเร็จแล้ว`,
            cancleBtnText: 'ยืนยัน',
            customStyle: 'background-color: #58595B;'
          }

          const modal = this.matDialog.open(ModalComponent, dialogConfig);
          return modal.afterClosed().pipe(
            map(res2 => {
              // console.log(res2);

              if (!res2) {
                window.opener.location.reload();
                setTimeout(() => {
                  window.close()
                }, 100);
              }
            })
          )
        } else {
          this.isLoading = false;
          alert(res.message);
          return of(null);
        }
      })
    ).subscribe()
  }

  onCoverSelected(e, measureForm) {
    const fileType = this.gbFunction.getTypeFile(e.target.files[0]);

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
      if (e.target.files && e.target.files[0]) {
        this.measureImg = e.target.files[0].name;

        const file = (e.target as HTMLInputElement).files[0];
        this.measureImgFile = file;

        measureForm.patchValue({
          measureImg: file,
          imgEdit: true
        });
        measureForm.get('measureImg').updateValueAndValidity()
      }
    } else {
      alert('การอัปโหลดรูปภาพรองรับไฟล์ JPG, JPEG, PNG เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  deleteMeasureImg(measureForm) {
    // console.log(measureForm);
    this.measureImg = '';
    measureForm.patchValue({
      measureImg: '',
      imgEdit: true
    });
    measureForm.get('measureImg').updateValueAndValidity()
  }

  deleteQuestion(id) {
    // console.log(id);
    this.questionDeleted.push(id);
    this.measureDetail = this.measureDetail.filter(m => m.ID !== id);
    // console.log(this.questionDeleted);
    // console.log(this.measureDetail);
  }

  getSelectedItem(e, measureForm) {
    // console.log(e);
    measureForm.controls['courseSuggest'].setValue(JSON.stringify(e.listOfValue));
  }

  patchSuggestCourse(values, isEdit) {
    this.measureForm.patchValue({
      courseSuggest: values.listOfValue
    });
    this.measureForm.get('courseSuggest').updateValueAndValidity();
  }


  clearValueMeasureDate(form) {
    form.value.alwaysOpen = !form.value.alwaysOpen;

    if (form.value.alwaysOpen) {
      form.controls['date'].setValue(null);
      form.controls['date'].clearValidators();
    } else {
      form.controls['date'].setValue(null);
      form.controls['date'].setValidators([Validators.required]);
    }
    form.controls['date'].updateValueAndValidity();
  }

  checkMoreThanZero(e) {
    if (e.target.value < 0) {
      e.target.value = 0;
    }
  }

  compareSuggestCourse(i1: any, i2: any): boolean {
    return i1 && i2 ? i1.COURSE_ID === i2.COURSE_ID : i1 === i2;
  }

  preview() {
    this.router.navigate(['/measure-management/preview-manage-test']);
  }

  patchMultiInformantValue() {
    this.measureForm.patchValue({
      informant_tag: this.informant_list
    });
    this.measureForm.get('informant_tag').updateValueAndValidity();

    console.log(this.measureForm);
  }

  clearInformant(form) {
    this.informant_list = [];
    form.patchValue({
      informant_tag: this.informant_list,
      showInformant: false,
    });
    // console.log(form.value.multi_informant)
    if (form.value.multi_informant) {
      form.controls['informant_tag'].setValidators([Validators.required]);
    } else {
      form.controls['informant_tag'].clearValidators();
    }

    form.get('informant_tag').updateValueAndValidity();
    form.get('showInformant').updateValueAndValidity();
  }

  getAllLearning() {
    this.learningCenterService.getAllLearningCenterAdmin().subscribe(
      res => {
        res.result.forEach(e => {
          this.allLearningCenter.push({
            CENTER_NAME: e.CENTER_NAME,
            CENTER_ID: e.CENTER_ID,
          })
        })
      });
  }

  patchLearning(val, form) {
    let value = [];
    value = val.listOfValue;
    // console.log(val);
    form.patchValue({
      centerId: value
    });
    form.get('centerId').updateValueAndValidity();
    // console.log(form.value);
  }

  compareLNFn(i1: any, i2: any): boolean {
    return i1 && i2 ? i1.CENTER_ID === i2.CENTER_ID : i1 === i2;
  }
}
